export default "__VITE_ASSET__gXKx_SSF__"